import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'viewSearch',
})
export class ViewSearchPipe implements PipeTransform {
  filteredResult = [];
  transform(value: any, args?: any): any {
    this.filteredResult = [];
    const tempArray = JSON.parse(JSON.stringify(value));
    if (tempArray && tempArray.length) {
      if (args.searchInput && args.searchType) {
        tempArray.filter((el, index) => {
          if (args.searchType === 'both') {
            if (el.name.toString().toLowerCase().includes(args.searchInput.toLowerCase())) {
              this.filteredResult.push(value[index]);
            }
          } else if (
            el.name.toString().toLowerCase().includes(args.searchInput.toLowerCase()) &&
            el.type.toString().toLowerCase() === args.searchType.toString().toLowerCase()
          ) {
            this.filteredResult.push(value[index]);
          }
        });
        return this.filteredResult;
      } else if (
        args.searchType &&
        (args.searchInput === undefined || args.searchInput === '' || args.searchInput === null)
      ) {
        tempArray.filter((el, index) => {
          if (args.searchType === 'both') {
            this.filteredResult.push(value[index]);
          } else if (el.type.toString().toLowerCase() === args.searchType.toString().toLowerCase()) {
            this.filteredResult.push(value[index]);
          }
        });
        return this.filteredResult;
      }
    } else {
      return value;
    }
  }
}
